export default __webpack_public_path__ + "static/media/en-hero-desktop.ad136582.mp4";